import styled from 'styled-components';
import { screenXsMax } from '@spotify-internal/encore-foundation';

// make this a switch case with different max widths by step
export const DialogWrapper = styled.div`
  display: flex;
  flex-direction: column;

  @media (min-width: ${screenXsMax}) {
    flex-direction: row;
    margin: 0 auto;
    max-width: 80%;
  }
`;
